






































































































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { storeUnit } from "@/store/modules/unit";
import { storeLogin } from "@/store/modules/login";
import { userModule } from "@/store/modules/user";
import DataObject from "@/utility/DataObject";
import {
  getReferenceData,
  getUserPreferenceData
} from "@/utility/ReferenceDataHelper";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import ReferensiUnit from "@/store/modules/new/ReferensiUnit";
import SystemSetting from "@/services/SystemSetting";
import ChangePasswordDialog from "@/components/ChangePasswordDialog.vue";
import { PanduanStoreModule } from "@/store/modules/PanduanStore";
import { daftarPasienRouteName } from "@/utils/unit";
import { ambilPesanLogin } from "@/utils/pesanLogin";

@Component({
  components: {
    ChangePasswordDialog
  }
})
export default class Login extends Vue {
  username = "";
  pass = "";
  error = false;
  text = "";
  unitSelected = this.unit;
  id = "";
  nama = "";
  valid = true;
  validationError = {};
  timeout = 2000;
  showEyeIcon = false;
  // host = window.location.host;
  host = "localhost";
  showChgPassDialog = false;
  loggingIn = false;

  mounted() {
    document.title = `RME_RSPS (emedika)`;

    appModule.closeErrorAlert();
    appModule.closeNotice();
    appModule.closeNoticeWithDelay();

    ReferensiUnit.getUnit();

    const pesan401 = ambilPesanLogin();

    if (pesan401) {
      // console.log("GO TO LOGIN PAGE", reqPar.message);
      // appModule.sendErrorAlert("ERR 401: " + reqPar.message);
      alert("ERR 401: " + pesan401);
    }
  }

  get unit() {
    // created return unit sementara - v model select unit
    let select = {};
    if (this.stateunit.length == 0) {
      select = {};
    } else {
      select = this.stateunit[0];
    }
    this.unitSelected = select;
    return select;
  }

  changeUnit(v) {
    this.unitSelected = v;
  }
  created() {
    storeUnit.act_on_all_by_ip(this.host);
    // storeUnit.act_on_all();
    this.clearFilter();
  }

  get stateunit() {
    return storeUnit.unit;
  }

  get stateuser() {
    return storeLogin.user;
  }

  get showAlert() {
    return appModule.alert;
  }

  get errItem() {
    return {
      errorMsg: appModule.alertMessage,
      errorIcon: "mdi-alert-circle-outline"
    };
  }

  public async login() {
    this.error = false;
    if (
      !this.loggingIn &&
      (this.$refs.form as Vue & { validate: () => boolean }).validate()
    ) {
      this.loggingIn = true;

      try {
        await userModule.signIn({
          username: this.username,
          password: this.pass,
          unit: this.unitSelected["nama"],
          unit_id: this.unitSelected["id"],
          unit_group_id: this.unitSelected["unit_group_id"],
          zona: this.unitSelected["zona"]
        });

        if (userModule.isModeSkriningPengunjung) {
          document.title = `${userModule.user?.nama}@RME_RSPS (emedika)`;
          this.$router.push({ name: "skrining-pengunjung-input" });
          userModule.getProfile();
          return;
        }

        if (!this.unitSelected?.["id"]) {
          await userModule.logout().catch(() => undefined);
          this.error = true;
          this.validationError = "Unit harus dipilih";
          return;
        }

        await getUserPreferenceData().catch(() => undefined);

        if (!userModule.isSignedIn) {
          return;
        }

        const enableDashboard = !!userModule.preference?.feature
          ?.enableDashboard;

        this.$router.push({
          name:
            userModule.user.map_cdoc && enableDashboard
              ? "dashboard-dokter"
              : daftarPasienRouteName(userModule.user.unit_id)
        });

        document.title = `${userModule.user?.nama}@RME_RSPS (emedika)`;

        const user = userModule.user,
          sipDiffMonths = moment(user.surat_registrasi.sip?.exp).diff(
            new Date(),
            "months"
          );

        let sipDiffText = "",
          expDateWarnText = "";

        if (
          user.surat_registrasi.sip &&
          sipDiffMonths >= 0 &&
          sipDiffMonths < 6
        ) {
          sipDiffText =
            sipDiffMonths === 0
              ? `pada tanggal ${moment(user.surat_registrasi.sip.exp).format(
                  "DD MMMM YYYY"
                )}`
              : `dalam ${sipDiffMonths} bulan lagi`;
          expDateWarnText = `SIP Anda akan habis masa berlakunya ${sipDiffText}.`;
        }

        const warnText = [
          expDateWarnText.trim(),
          "Silahkan hubungi Bagian Umum dan Kepegawaian untuk info lebih lanjut."
        ].join("\r\n");

        if (sipDiffText) {
          appModule.sendErrorAlert(warnText);
        }

        userModule.getProfile();

        getReferenceData();

        PanduanStoreModule.fetchPanduan();
      } catch (err) {
        this.error = true;
        this.validationError = err["text"].message;
      } finally {
        this.loggingIn = false;
      }
    }
  }

  clearFilter() {
    DataObject.filterCari.tanggal = "";
    DataObject.filterCari.status = "";
    DataObject.filterCari.dokter = "";
    DataObject.filterCari.count = 0;
  }

  get unitAllList() {
    return ReferensiUnit.unit;
  }

  unitIconClickCount = 0;
  dialog = false;
  unitSet = null;
  unitSetPass = "";
  unitTimeRange = null;
  unitShowEyeIcon = false;
  unitSaveLoading = false;
  timeRangeOpt = [
    {
      val: 2,
      name: "2 Menit"
    },
    {
      val: 1,
      name: "1 Hari"
    },
    {
      val: 3,
      name: "3 Hari"
    },
    {
      val: 7,
      name: "7 Hari"
    },
    {
      val: 30,
      name: "1 Bulan"
    },
    {
      val: 360,
      name: "1 Tahun"
    },
    {
      val: 0,
      name: "Selamanya"
    },
    {
      val: -1,
      name: "Hapus"
    }
  ];

  @Watch("dialog")
  changeDialog(val) {
    if (!val) {
      this.unitSetPass = "";
      this.unitTimeRange = null;
      this.unitSet = null;
    }
  }

  showUnitSetting() {
    this.unitIconClickCount++;

    if (this.unitIconClickCount === 1) {
      setTimeout(() => {
        if (this.unitIconClickCount >= 3) {
          // alert("show unit setting");
          this.dialog = true;
        }

        this.unitIconClickCount = 0;
      }, 1000);
    }
  }

  sendUnitSetting() {
    this.unitSaveLoading = true;

    SystemSetting.setClientUnit({
      unit_id: this.unitSet,
      pass: this.unitSetPass
    })
      .then(resp => {
        if (resp.status == 1) {
          this.dialog = false;

          location.reload();
        } else {
          alert(resp.message);
        }
      })
      .catch(err => {
        alert(err.response?.data?.message);
      })
      .finally(() => {
        this.unitSaveLoading = false;
      });
  }

  toLupaPassword() {
    window.location.replace(process.env.VUE_APP_RESET_PASSWORD_URL);
  }
}
